import axios from "axios";
import env from "../environment";

// Cliente reservado para endpoints que ainda dependem do hub-backend legado.
// Regra pratica:
// - prefira services/api para tudo que roda no backend principal do frontend_hub
// - use este client somente quando o endpoint existir exclusivamente em API_HUB
function getAuthorizationHeader() {
  if (typeof window === "undefined") return null;
  const token = localStorage.getItem("@HubEverlog:token");
  return token ? `Bearer ${token}` : null;
}

const ApiHubBackend = axios.create({
  baseURL: env.API_HUB,
  headers: {
    "Content-Type": "application/json;charset=utf-8",
    ...(getAuthorizationHeader() ? { Authorization: getAuthorizationHeader() } : {}),
  },
});

ApiHubBackend.interceptors.request.use((config) => {
  const authorization = getAuthorizationHeader();

  if (authorization) {
    if (typeof config.headers?.set === "function") {
      config.headers.set("Authorization", authorization);
    } else {
      config.headers = {
        ...(config.headers || {}),
        Authorization: authorization,
      };
    }
  }

  if (typeof FormData !== "undefined" && config?.data instanceof FormData) {
    if (typeof config.headers?.delete === "function") {
      config.headers.delete("content-type");
      config.headers.delete("Content-Type");
    } else if (config.headers) {
      delete config.headers["content-type"];
      delete config.headers["Content-Type"];
    }
  }

  return config;
});

export default ApiHubBackend;
